export const getSvg = (color) => {
  return `
  data:image/svg+xml;utf8,
  <svg width="250px" height="250px" viewBox="0 0 250 250" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->
      <desc>Created with Sketch.</desc>
      <defs>
          <radialGradient cx="50%" cy="50%" fx="50%" fy="50%" r="48.0996891%" id="radialGradient-1">
              <stop stop-color="#FFF" stop-opacity="1.0" offset="0%"></stop>
              <stop stop-color="${color}" stop-opacity="1.0" offset="75%"></stop>
              <stop stop-color="${color}" stop-opacity="0" offset="100%"></stop>
          </radialGradient>
      </defs>
      <g id="Page-1" stroke="none" stroke-width="1" fill="rgba(0,0,0,0.0)" fill-rule="evenodd">
          <g id="Desktop" transform="translate(-295.000000, -163.000000)" fill="url(#radialGradient-1)">
              <circle id="Oval" cx="420" cy="288" r="130"></circle>
          </g>
      </g>
  </svg>
  `
}

export const images = [
  {
    name: 'default.svg',
    src: getSvg('#ff0000')
  },
  {
    name: 'real-star-1.png',
    src: require('@/components/Scenes/Home/StarField/img/real-star-1.png')
  }
]

export const seed = {
  root: {
    starClouds: [
      {
        simSimCycle: 1.1,
        particleSize: 1.3,
        cloudScale: 1.3,
        stars: 10000,
        spreadOfStars: 1000,
        image: images[0].name,
        color: '#428dc5',
        texture: getSvg('#428dc5')
      },
      {
        simSimCycle: 6.0,
        particleSize: 1.5,
        cloudScale: 2.1,
        stars: 1000,
        spreadOfStars: 2000,
        image: images[0].name,
        color: '#00b8bb',
        texture: getSvg('#00b8bb')
      },
      {
        simSimCycle: 2.4,
        particleSize: 1.25,
        cloudScale: 1.5,
        stars: 10000,
        spreadOfStars: 1000,
        image: images[0].name,
        color: '#838383',
        texture: getSvg('#838383')
      },
      {
        simSimCycle: 1.2,
        particleSize: 1.8,
        cloudScale: 0.4,
        stars: 100,
        spreadOfStars: 1000,
        image: images[0].name,
        color: '#0e00bb',
        texture: getSvg('#0e00bb')
      },
      {
        simSimCycle: 1.5,
        particleSize: 1.0,
        cloudScale: 1.2,
        stars: 10000,
        spreadOfStars: 700,
        image: images[0].name,
        color: '#b1e4f1',
        texture: getSvg('#b1e4f1')
      },
      {
        simSimCycle: 2.1,
        particleSize: 1.0,
        cloudScale: 1.0,
        stars: 10000,
        spreadOfStars: 1000,
        image: images[0].name,
        color: '#3cbb00',
        texture: getSvg('#3cbb00')
      }
    ]
  }
}

export const state = {
  root: {
    starClouds: []
  }
}

const ls = window.localStorage

export const ns = '@star-cloud-funz-demo:'
export const rootName = `${ns}root`

export const setLS = (n, v) => {
  ls.setItem(n, JSON.stringify(v))
}

export const getLS = (v) => {
  var output = ls.getItem(v)
  if (output) {
    return JSON.parse(output)
  } else {
    return false
  }
}

export const seedPrj = ({ force }) => {
  if (
    force ||
    (window.confirm('seed project and reset all?') && window.confirm('are you sure?'))
  ) {
    state.root = JSON.parse(JSON.stringify(seed.root))
  }
}

export const persist = () => {
  setLS(rootName, state.root)
}

export const listenOnLeave = () => {
  window.addEventListener('beforeunload', () => {
    var local = JSON.stringify(getLS(rootName))
    var ram = JSON.stringify(state.root)

    if (local !== ram) {
      persist()
    }
  }, false)
}

export const hydrate = () => {
  listenOnLeave()
  var local = getLS(rootName)
  if (!local) {
    seedPrj({ force: true })
    setLS(rootName, seed.root)
  } else {
    state.root = local
  }
}

export const readFiles = ({ files }) => {
  console.log(files)
  var firstFile = files[0]
  if (firstFile) {
    var reader = new FileReader()
    reader.onload = () => {
      importJSON({ data: reader.result })
    }
    reader.readAsText(firstFile)
  }
}

export const exportJSON = () => {
  var data = JSON.stringify(state.root, null, '  ')
  var url = window.URL.createObjectURL(new Blob([data]))
  var anchor = document.createElement('a')
  anchor.href = url
  anchor.download = ns + new Date().getTime() + '.json'
  anchor.click()
}

export const importJSON = ({ data }) => {
  if (window.confirm('replace all settings?')) {
    state.root = JSON.parse(data)
  }
}



// WEBPACK FOOTER //
// ./src/components/Parts/StarCloud/StarCloud.js